import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router'

const Tabing = ({ bottomTabs, style, className, activeKey, onChange = () => { }, defaultActive, isExtraComponent = false, ExtraComponent = () => { } }) => {
    const [activeTab, setActiveTab] = useState("/")
    const location = useLocation();

    useEffect(() => {
        let current = bottomTabs?.find(tab =>
            tab.url && location.pathname.startsWith(tab.url)
        );

        if (current && !defaultActive) {
            setActiveTab(current.activeKey);
        } else {
            if (defaultActive) {
                setActiveTab(defaultActive)
            }
            else {
                setActiveTab(bottomTabs[0]?.activeKey || "");
            }
        }
    }, [location.pathname, bottomTabs, defaultActive]);

    return (
        <div className={`${style.headerBottom_tabs} ${className?.headerBottom_tabs}`}>
            {bottomTabs?.map((eachTab, i) => {
                return (
                    eachTab.hasOwnProperty("url") ?
                        <Link key={i} to={eachTab?.url} className={`${style.headerBottom_tabs__items} ${className?.headerBottom_tabs__items} ${(activeTab === eachTab?.activeKey) ? (`${style.active} ${className?.active}`) : ""}`} onClick={(e) => {
                            if (!eachTab?.url) {
                                e.preventDefault(); // 👈 prevent navigation
                                return;
                            }
                            setActiveTab(eachTab?.activeKey);
                            onChange("")
                        }}>
                            <span>{eachTab?.name}</span>
                        </Link>
                        :
                        <div
                            key={i}
                            className={`${style.headerBottom_tabs__items} ${className?.headerBottom_tabs__items} ${(activeTab === eachTab?.[activeKey]) ? (`${style.active} ${className?.active}`) : ""}`}
                            onClick={() => {
                                setActiveTab(eachTab?.[activeKey])
                                onChange(eachTab?.[activeKey])
                            }}
                        >
                            <span>{(eachTab?.name == "Loyality Fund Companys Contribution" ? "Loyality Fund" : eachTab?.name)}</span>
                        </div>

                )
            })}
            {isExtraComponent ?
                <ExtraComponent className={`${style.headerBottom_tabs__items} ${className?.headerBottom_tabs__items}`} />
                :
                null
            }
        </div>
    )
}

export default Tabing
